import { storageManager } from 'utils/storageUtils';

export const authStorage = storageManager.createOrFetchStorage<string>('authentication');

export const lastLoginStorage = storageManager.createOrFetchStorage<number>('lastLogin');

export const userIdStorage = storageManager.createOrFetchStorage<string>('userId');
